export default __webpack_public_path__ + "static/superbetter-2-6240e6d56d0b9cb657ea85e4c1fbc02f.webp";